import React from "react";
import { Typography } from "@mui/material";

const Logo = ({ className, ...rest }) => {
    return (
        <Typography
            variant="h4"
            className={className}
            sx={{
                fontWeight: 700,
                color: "primary.main",
                display: "flex",
                alignItems: "center",
            }}
            {...rest}
        >
            Kombucha Co
        </Typography>
    );
};

export default Logo;
